<style scoped>
</style>

<template>
    <v-avatar tile :size="size" :color="logo ? 'transparent' : 'primary'" :style="getStyle()" @click="$emit('click')">
        <img v-if="logo && !error" alt="Logo" :src="getImage()" @error="imageError">
    </v-avatar>
</template>

<script>
//import events from "../../app/app.events";

export default {
    props: {
        size: {},
        logo: {},
    },
    data: function () {
        return {
            error: false
        }
    },
    mounted: function () {
    },
    created: function () {
    },
    computed: {
    },
    watch: {
        avatar() {
            this.error = false;
        }
    },
    methods: {
        imageError() {
            this.error = true;
            this.$emit("logoerror", {});
        },
        getStyle() {
            if (this.size >= 50) {
                return { "font-size": "40px" };
            }
            return {};
        },
        getImage() {
            var imageSize = "medium";
            if (this.size < 50) {
                imageSize = "thumbnail";
            }
            return this.$asset.getUrl(this.logo, imageSize);
        }
    },
    components: {
    }
}
</script>